import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { ProductsAction } from './products.actions';

export class ProductsStateModel {
  public items: any;
}

const defaults = {
  items: {},
};

@State<ProductsStateModel>({
  name: 'products',
  defaults,
})
@Injectable()
export class ProductsState {
  @Selector()
  static getProduct(state: ProductsStateModel) {
    return state;
  }

  @Action(ProductsAction.Set)
  add(ctx: StateContext<ProductsStateModel>, action: ProductsAction.Set) {
    const state = ctx.getState();
    
    Object.assign(state.items, action.items);
    ctx.setState({ ...state });
  }
}
